import { render } from "./InlineLoader.vue?vue&type=template&id=5bd91aa6&scoped=true"
import script from "./InlineLoader.vue?vue&type=script&lang=js"
export * from "./InlineLoader.vue?vue&type=script&lang=js"

import "./InlineLoader.vue?vue&type=style&index=0&id=5bd91aa6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd91aa6"]])

export default __exports__